import { type Locale } from "@/types";
import { removeLocaleFromPath } from "@/utils/locale/removeLocaleFromPath";
import { getPathSliceFromIndex } from "@/utils/url/getPathSliceFromIndex";

export interface GetPagePathFromPathnameParams {
  pathname: string;
  isSingleSiteMode: boolean;
  isPreview: boolean;
  locale?: Locale;
}

export function getPagePathFromPathname(params: GetPagePathFromPathnameParams) {
  const { pathname, isSingleSiteMode, isPreview, locale } = params;

  const updatedPathname = locale
    ? removeLocaleFromPath(pathname, locale)
    : pathname;

  return isSingleSiteMode
    ? getPathSliceFromIndex(updatedPathname, isPreview ? 2 : 0)
    : getPathSliceFromIndex(updatedPathname, isPreview ? 3 : 1);
}
